import { dashboardOverviewResponseSchema, type DashboardOverview } from "@repo/shared";
import { API_V1_PREFIX, apiRequestJson } from "../api-client";

export async function getDashboardOverview(): Promise<DashboardOverview> {
  const res = await apiRequestJson({
    path: `${API_V1_PREFIX}/dashboard/overview`,
    responseSchema: dashboardOverviewResponseSchema,
    badResponseMessage: "Unexpected response from server",
  });
  return res.data;
}
